import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";
import { formatarParaMoedaBRL } from "../../../utils";
import { Card } from "primereact/card";




export default function ProtestoQuod({
  protestos
}: {
  protestos: any
}) {
  const { t } = useTranslation();

  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {protestos && protestos.length > 0 ? (<span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('Protestos SP')}</span></span>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>{t('Protestos SP')}</span>)} </div>;
  }

  const getResumoProtesto = () => {
    const resumos: any[] = [];

    resumos.push({
      icon: 'pi pi-chart-line',
      label: 'Quantidade Cartórios',
      value: 0
    })
    resumos.push({
      icon: 'pi pi-gauge',
      label: 'Quantidade Protestos',
      value: 0
    })
    resumos.push({
      icon: 'pi pi-dollar',
      label: 'Valor Total Protestos',
      value: '0'
    })
    let valorTotal = 0.0
    let quantidade = 0;
    const comarcas: any[] = []
    protestos.forEach((prot: any) => {
      quantidade = quantidade + Number(prot.quantidade);
      if (prot.valor) {
        valorTotal = valorTotal + Number(prot.valor.replaceAll('.', '').replace(',', '.'))
      }

      if (!comarcas.includes(prot.cartorio)) {
        comarcas.push(prot.cartorio)
      }
    });
    resumos[0].value = comarcas.length;
    resumos[1].value = quantidade;
    resumos[2].value = formatarParaMoedaBRL(valorTotal);


    return resumos;
  }

  return (
    <Panel headerTemplate={headerTemplate}>
      {!protestos || protestos.length === 0 ? (<NadaConsta />) : (
        <div>
          <div className="flex-consulta  flex-wrap gap-3">
            {getResumoProtesto().map((item: any, index: number) => (

              <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                <div className="flex-consulta  justify-content-between gap-5">
                  <div className="flex-consulta  flex-column gap-1">
                    <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                    <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                  </div>
                  <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                    <i className={item.icon} />
                  </span>
                </div>
              </Card>

            ))}
          </div>
          <br></br>
          <DataTable size="small" value={protestos} tableStyle={{ minWidth: '50rem' }}>
            <Column field="cartorio" header={t('cartorio')}></Column>
            <Column field="endereco" header={t('endereco')}></Column>
            <Column field="cidade" header={t('cidade')}></Column>
            <Column field="uf" header={t('uf')}></Column>
            <Column field="telefone" header={t('telefone')}></Column>
            <Column field="quantidade" header={t('quantidade')}></Column>
            <Column field="valor" header={t('valor')}></Column>
          </DataTable>
        </div>
      )}
    </Panel>
  )
}